// extracted by mini-css-extract-plugin
export var mainContainer = "SectionNarrowText-module--mainContainer--9354a";
export var narrowText = "SectionNarrowText-module--narrowText--2da4c";
export var sourceText = "SectionNarrowText-module--sourceText--cb31a";